import { gql } from '@apollo/client';

const LOGIN_MUTATION = gql`
  mutation Login($username: String!, $password: String!, $clientMutationId: String!) {
    login(input: {
      username: $username,
      password: $password,
      clientMutationId: $clientMutationId
    }) {
      authToken
    }
  }
`;

const STORAGE_KEY = 'jwt_token';

export function isTokenValid(token) {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp && payload.exp > now;
  } catch (e) {
    return false;
  }
}

export async function getValidToken(apolloClient) {
  const storedToken = localStorage.getItem(STORAGE_KEY);
  if (isTokenValid(storedToken)) return storedToken;

  const res = await apolloClient.mutate({
    mutation: LOGIN_MUTATION,
    variables: {
      username: process.env.REACT_APP_WP_USER ? process.env.REACT_APP_WP_USER : 'payretailer_front_user',
      password: process.env.REACT_APP_WP_PASS ? process.env.REACT_APP_WP_PASS : 'B@PKsoSxs8t&RvJ4J@s*4RDN',
      clientMutationId: `auto-login-${Date.now()}`,
    },
  });

  const newToken = res?.data?.login?.authToken;
  if (newToken) {
    localStorage.setItem(STORAGE_KEY, newToken);
    return newToken;
  }

  throw new Error('Error getting valid token');
}
